require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./2018-06-24-delia-posts-index-2.json") })
        }
      }, "path---2018-06-24-delia-posts-index-2");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---2018-06-24-delia-posts-index-2!./.cache/json/2018-06-24-delia-posts-index-2.json
// module id = 504
// module chunks = 231608221292675